<template>
  <div class="dialog-wrap">
    <el-dialog
      title="用户详情"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="680px">
      <div class="main-wrap">
        <div class="card-wrap">
          <div class="inner">
            <div class="title">基础信息</div>
            <div class="info-wrap">
              <div class="info-row">
                <div class="label">头像：</div><div class="value"><img v-if="content.avatar" :src="content.avatar"><span v-else>--</span></div>
              </div>
              <div class="info-row">
                <div class="label">姓名：</div><div class="value">{{content.realname || '--'}}</div>
              </div>
              <div class="info-row">
                <div class="label">昵称：</div><div class="value">{{content.nickname || '--'}}</div>
              </div>
              <div class="info-row">
                <div class="label">手机号：</div><div class="value">{{content.mobile || '--'}}</div>
              </div>
              <div class="info-row">
                <div class="label">邮箱：</div><div class="value">{{content.email || '--'}}</div>
              </div>
              <div class="info-row">
                <div class="label">性别：</div><div class="value">{{content.gender ? (content.gender == 1 ? '男' : '女') : '--'}}</div>
              </div>
              <div class="info-row">
                <div class="label">角色：</div><div class="value">{{content.role ? (content.role == 1 ? '学生' : '学长') : '--'}}</div>
              </div>
              <div class="info-row">
                <div class="label">当前所在地：</div><div class="value">{{content.location ? (content.location.area || '--') : '--'}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="inner">
            <div class="title">本科信息</div>
            <div class="info-wrap">
              <div class="info-row">
                <div class="label">院校名称：</div><div class="value">{{content.present ? `(${content.present.college_code})${content.present.college_name}` : '--'}}</div>
              </div>
              <div class="info-row">
                <div class="label">专业名称：</div><div class="value">{{content.present ? `(${content.present.major_code})${content.present.major_name}` : '--'}}</div>
              </div>
              <div class="info-row">
                <div class="label">学习状态：</div><div class="value">{{content.present ? ({'1': '在校', '2': '在职'}[content.present.study_status] || '其他') : '--'}}</div>
              </div>
              <div class="info-row">
                <div class="label">考研次数：</div><div class="value">{{content.present ? `${content.present.apply_count}次` : '--'}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="inner">
            <div class="title">报考信息</div>
            <div class="info-wrap">
              <div class="info-row">
                <div class="label">院校名称：</div><div class="value">{{content.applicant ? `(${content.applicant.apply_college_code})${content.applicant.apply_college_name}` : '--'}}</div>
              </div>
              <div class="info-row">
                <div class="label">专业名称：</div><div class="value">{{content.applicant ? `(${content.applicant.apply_major_code})${content.applicant.apply_major_name}` : '--'}}</div>
              </div>
              <div class="info-row">
                <div class="label">考研年份：</div><div class="value">{{content.applicant ? `${content.applicant.apply_year}年` : '--'}}</div>
              </div>
              <div class="info-row">
                <div class="label">申请次数：</div><div class="value">{{content.applicant ? `${content.applicant.apply_count}次` : '--'}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="inner">
            <div class="title">其他信息</div>
            <div class="info-wrap">
              <div class="info-row">
                <div class="label">注册来源：</div><div class="value">{{content.register_source || '--'}}</div>
              </div>
              <div class="info-row">
                <div class="label">注册时间：</div><div class="value">{{$moment(content.register_time).format('YYYY.MM.DD HH:mm')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => {return {}}
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
    }
  },
  watch: {
    visible (val) {
      this.dialogVisible = val
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
  }
}
</script>

<style lang="less" scoped>
  .dialog-wrap {

    .main-wrap {
      margin: -5px;
    }
    .card-wrap {
      width: 100%;
      padding: 5px;

      .inner {
        min-height: 100px;
        border: 1px dashed #ccc;
        border-radius: 6px;
        padding: 5px 5px 10px;
      }
      .title {
        font-size: 14px;
        font-weight: bold;
      }
      .info-wrap {
        margin-top: 15px;
      }
      .info-row {
        display: flex;
        align-items: center;
        font-size: 13px;

        & + .info-row {
          margin-top: 10px;
        }

        .label {
          width: 100px;
          text-align: right;
          color: #666;
        }
        .value {
          flex: 1;
          color: #333;
          margin-left: 10px;
        }
        img {
          max-width: 40px;
        }
      }
    }

    /deep/ .el-dialog__body {
      padding-top: 10px;
    }
  }
</style>
